import { Button, Card, Form, Input, Segmented, Select, Space } from 'antd';
import { useForm } from '@refinedev/antd';
import { IExperienceEvent } from '../../../interfaces/experience';

const fields = [
  'id',
  'place',
  'schedule',
  'target',
  'pricing',
  'belongings',
  'url',
  'paymentDescription',
  { image: ['id', 'url'] },
];

export const DetailForm = () => {
  const { formProps, form, mutationResult, queryResult } = useForm<IExperienceEvent>({
    resource: 'experienceEvents',
    action: 'edit',
    redirect: false,
    meta: {
      fields,
    },
    mutationMeta: {
      fields: [{ experienceEvent: fields }],
    },
  });

  const isLoading = queryResult?.isLoading || mutationResult?.isLoading;

  return (
    <Form data-test-id="DetailForm" layout="vertical" {...formProps}>
      <Card
        title="詳細"
        extra={
          <Space align="end">
            <Button type="primary" htmlType="submit" loading={isLoading}>
              保存
            </Button>
            <Button onClick={() => form.resetFields()}>リセット</Button>
          </Space>
        }
      >
        <Form.Item label="場所" name="place">
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="スケジュール" name="schedule">
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="料金" name="pricing">
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="対象" name="target">
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="持ち物" name="belongings">
          <Input.TextArea />
        </Form.Item>
        <Form.Item label="外部予約URL" name="url">
          <Input />
        </Form.Item>
        <Form.Item label="支払い注意事項" name="paymentDescription">
          <Input.TextArea />
        </Form.Item>
      </Card>
    </Form>
  );
};
